import { styled as muiStyled } from '@gogame/ui/styles';

export const styled = muiStyled;

export default styled;
